import React from 'react';
import PropTypes from 'prop-types';
import Text from '../../Text';
import { ExtraTextProps } from './ExtraText.types';

const ExtraText = ({ dataHook, text }: ExtraTextProps) => {
  return (
    <Text secondary dataHook={dataHook}>
      {text}
    </Text>
  );
};

ExtraText.propTypes = {
  dataHook: PropTypes.string,
  text: PropTypes.string.isRequired,
};

export default ExtraText;
